import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store'
import router from './router'
import interceptorsSetup from './helpers/interceptors.js'
import 'vue-material-design-icons/styles.css'
import axios from 'axios'
interceptorsSetup()
Vue.config.productionTip = false
axios.defaults.withCredentials = true
new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
